import React from 'react';

const Pagination = ({ pagination, onPageChange, onPerPageChange }) => {
  const total = Number(pagination?.total) || 0;
  const perPage = Number(pagination?.per_page) || 15;
  const currentPage = Number(pagination?.page) || 1;

  if (!pagination || total <= perPage) {
    return null;
  }

  const totalPages = Math.max(1, Math.ceil(total / perPage));

  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, currentPage + 2);

  return (
    <div className="pagination">
      <button
        type="button"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        First
      </button>
      <button
        type="button"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      >
        Previous
      </button>

      <div className="page-numbers">
        {startPage > 1 && (
          <>
            <span className="page-number" onClick={() => onPageChange(1)}>1</span>
            {startPage > 2 && <span>...</span>}
          </>
        )}

        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
          <span
            key={page}
            className={`page-number ${page === currentPage ? 'active' : ''}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </span>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span>...</span>}
            <span className="page-number" onClick={() => onPageChange(totalPages)}>
              {totalPages}
            </span>
          </>
        )}
      </div>

      <button
        type="button"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
      <button
        type="button"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        Last
      </button>

      <span className="pagination-info">
        Page {currentPage} of {totalPages} ({total} total)
      </span>

      <select
        value={String(perPage)}
        onChange={(e) => {
          const v = parseInt(e.target.value, 10) || 15;
          localStorage.setItem('per_page', String(v));
          if (typeof onPerPageChange === 'function') {
            onPerPageChange(v);
          } else {
            onPageChange(1);
          }
        }}
      >
        <option value="10">10 per page</option>
        <option value="15">15 per page</option>
        <option value="25">25 per page</option>
        <option value="50">50 per page</option>
        <option value="100">100 per page</option>
      </select>
    </div>
  );
};

export default Pagination;

